import { LocalStorage } from "quasar";

import useMembership from "src/use/membership";
import useAcc from "src/use/accounts";
import useCore from "src/use/core";
import usePort from "src/use/portfolio";

export function setToken(state, token) {
  state.token = token;
  state.isAuthenticated = true;
  LocalStorage.set("token", token);
}

export function updateToken(state, token) {
  state.isAuthenticated = true;
  state.token.access = token.access;
  state.token.refresh = token.refresh;
  LocalStorage.set("token", token);
  LocalStorage.set("validatingOtp", false);
}

export function setRefreshingState(state, isRefreshing) {
  state.isRefreshing = isRefreshing;
}

export function setRefreshingCall(state, refreshingCall) {
  state.refreshingCall = refreshingCall;
  LocalStorage.set("refreshingCall", refreshingCall);
}

export function purgeToken(state) {
  state.isAuthenticated = false;
  state.token = {};
  LocalStorage.remove("token");
  LocalStorage.remove("isRefreshing");
  LocalStorage.remove("refreshingCall");
  LocalStorage.remove("whoAmI");
  LocalStorage.remove("package");
  LocalStorage.remove("chukulPack");
  useMembership().clearMembershipCache();
  useAcc().clearUserCache();
  useCore().clearCoreCache();
  usePort().clearPortCache();
}
